import { Col, Row } from "antd";
import { UserAccountIcon } from "../../../../../assets/icons/UserAccountIcon";
import AText from "core/presentation/components/Text";
import ATitle from "core/presentation/components/Title";
import { useAppDispatch, useAppSelector } from "core/presentation/store/hooks";
import { color } from "theme/Color";
import { QuickReorderIcon } from "../../../../../assets/icons/QuickReorderIcon";
import { VanIcon } from "../../../../../assets/icons/VanIcon";
import { useEffect, useState } from "react";
import Loader from "core/presentation/components/Loader";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "core/presentation/components/CofirmationBox";
import { ClockCircleFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import { userThunks } from "user/presentation/store/userSlice";

const UsernamePoints = () => {
  const { userProfile, dashboardData } = useAppSelector((state) => state.user);
  const companyName = userProfile?.user?.company?.companyName;
  const name = companyName || `${userProfile?.user?.firstName} ${userProfile?.user?.middleName ?? ""} ${userProfile?.user?.lastName}`;
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const hasPendingTransactions = userProfile?.user?.pendingTransactionId ?? false;
  const dispatch = useAppDispatch();

  const clickHandler = () => {
    if (hasPendingTransactions) {
      const transactionId = userProfile?.user?.pendingTransactionId;
      if (transactionId?.startsWith("TXN-")) {
        navigate(`/point/payment-completed?TXNID=${transactionId}`);
      } else {
        navigate(`/point/payment-completed?validationTraceId=${transactionId}`);
      }
    } else {
      navigate("/point-report");
    }
  };

  useEffect(() => {
    dispatch(userThunks.getUserProfileThunk());
  }, [dispatch]);

  if (!dashboardData) {
    return <Loader />;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px",
          border: "1px solid #EAECF0",
          borderRadius: "8px",
          marginBottom: "20px",
          background: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <UserAccountIcon style={{ marginRight: "10px" }} />
          <ATitle content={name} fontSize={16} fontWeight={600} marginTop="0" lineHeight={2} />
        </div>
        <Tooltip title={hasPendingTransactions ? "Pending Payment Verification. Click to verify." : ""}>
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              cursor: "pointer",
              background: isHovered ? color.SHADOW_ORANGE : "#f0eeeeff",
              color: isHovered ? color.WHITE : color.DARK,
              padding: "10px 20px",
              borderRadius: "8px",
              transition: "background 0.2s ease-in-out",
            }}
            onClick={clickHandler}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {hasPendingTransactions && (
              <ClockCircleFilled
                style={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  color: "#faad14",
                  fontSize: 16,
                }}
              />
            )}

            <AText fontSize={12} fontWeight={700}>
              Points
            </AText>

            <AText style={{ fontWeight: "bold", fontSize: 24 }}>{userProfile?.user?.point ?? 0}</AText>
          </div>
        </Tooltip>
      </div>

      <Row gutter={[16, 16]}>
        <Col md={6}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
              padding: "20px",
              border: "1px solid #EAECF0",
              borderRadius: "8px",
              background: "#F26533",
              color: "#fff",
            }}
          >
            <div>
              <ATitle content={"Orders in Progress"} fontSize={12} fontWeight={600} marginTop="0" lineHeight={2} textColor={color.WHITE} />
              <AText fontSize={24} fontWeight={700} mode="white">
                {dashboardData?.order_progress ?? 0}
              </AText>
            </div>
            <QuickReorderIcon />
          </div>
        </Col>
        <Col md={6}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
              padding: "20px",
              border: "1px solid #EAECF0",
              borderRadius: "8px",
              background: "#8F2CF3",
            }}
          >
            <div>
              <ATitle content={"No. of Vehicles"} fontSize={12} fontWeight={600} marginTop="0" lineHeight={2} textColor={color.WHITE} />
              <AText fontSize={24} fontWeight={700} mode="white">
                {dashboardData?.no_of_vehicles ?? 0}
              </AText>
            </div>

            <VanIcon />
          </div>
        </Col>
      </Row>
      <ConfirmationModal visible={showConfirmModal} onConfirm={() => setShowConfirmModal(false)} onCancel={() => setShowConfirmModal(false)} confirmationMessage="Are you sure you want to continue?" />
    </>
  );
};

export default UsernamePoints;
function useFocusEffect(arg0: () => void) {
  throw new Error("Function not implemented.");
}
